<template>
	<div class="unlock-container">
		<UnlockForm @rcfail="resetRC" @executeRC="executeRC" />
	</div>
</template>

<script>
import UnlockForm from '@/components/Form/UnlockForm'

export default {
	name: 'UnlockContainer',
	components: {
		UnlockForm,
	},
  methods: {
    resetRC() {
      this.$emit('resetRC')
    },
    executeRC() {
      this.$emit('executeRC')
    }
  },
}
</script>

<style lang="scss">
.unlock-container {
	padding: 2em 1em 3em 1em;
}
</style>